import { Seo } from '../components/Seo'
import { PageHeader } from '../components/common/PageHeader'
import { Accordion, type AccordionItem } from '../components/common/Accordion'
import { Button } from '../components/common/Button'
import { Icon } from '../components/common/Icon'
import { faqs } from '../data/faq'
import { faqSchema, breadcrumbSchema } from '../lib/seo'

export default function FaqPage() {
  const items: AccordionItem[] = faqs.map((f, i) => ({
    id: `faq-${i}`,
    title: f.q,
    content: <p className="leading-relaxed">{f.a}</p>,
    defaultOpen: i === 0,
  }))

  return (
    <>
      <Seo
        title="Frequently Asked Questions | GreenbayBio"
        description="Answers about GreenbayBio bio-fertilizers, biostimulants and foliar products — approvals, how they work, mixing, storage, choosing products and partnering with us."
        path="/faq"
        jsonLd={[
          faqSchema(faqs.map((f) => ({ q: f.q, a: f.a }))),
          breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'FAQ', path: '/faq' }]),
        ]}
      />
      <PageHeader
        eyebrow="Help & answers"
        title="Frequently asked questions."
        subtitle="Straight answers about our products, approvals, application and partnering — grounded in our product information."
      />

      <div className="container-x grid gap-12 py-14 lg:grid-cols-[1.4fr_0.6fr]">
        <Accordion items={items} />

        <aside className="lg:sticky lg:top-28 lg:self-start">
          <div className="rounded-2xl border border-sand-200 bg-white p-7 shadow-soft">
            <h2 className="font-display text-xl font-semibold text-ink">Still have a question?</h2>
            <p className="mt-2 text-sm text-ink-500">Our team is happy to help with product or agronomic questions.</p>
            <div className="mt-5 flex flex-col gap-3">
              <Button to="/contact" variant="primary" size="md">
                Contact us <Icon name="ArrowRight" className="h-4 w-4" />
              </Button>
              <Button to="/crop-solutions" variant="outline" size="md">
                Find products by crop
              </Button>
            </div>
          </div>
        </aside>
      </div>
    </>
  )
}
